import { getCurrentStep, getIsModified } from "./redux/selectors";
import { steps } from "./util/constants";

export function onModifiedChange(store, callback) {
  store.subscribe(() => {
    const state = store.getState();
    const currentStep = getCurrentStep(state);
    if (
      [
        steps.preview,
        steps.configureLocations,
        steps.configureClickAction,
        steps.configureHoverAction,
        steps.pickTheme,
        steps.configurePointerText,
      ].includes(currentStep)
    ) {
      const isModified = getIsModified(state);
      callback(isModified);
    } else {
      callback(false); // this is essential
    }
  });
}
